import { useDispatch } from 'react-redux';
import { ClearingsActions } from './actions';
import { ManualUploadOptions } from '@card/commonlib';
import { useShallowEqualSelector } from '../../utils/reduxUtils';

export function useClearingUploadData() {
  const dispatch = useDispatch();
  const fileUploaded = useShallowEqualSelector((s) => s.clearings.uploadScreen.fileUploaded);
  const addFiles = (params: ManualUploadOptions) => {
    dispatch(ClearingsActions.manualUploadStarted(params));
  };

  return {
    addFiles,
    fileUploaded
  };
}
